import {createStyles, Theme} from "@material-ui/core";
import {typography} from "src/main.style";

export const RadioAccordionStyle = (theme: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        borderBottom: '1px solid',
        borderColor: theme.palette.common.black,
        padding: theme.spacing(1.5, 0),
    },
    label: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(2),
        alignItems: 'center',
        color: theme.palette.common.black,
    },
    labelText: {
        ...typography.button,
        color: theme.palette.common.black,
    },
    checkedLabelText: {
        fontWeight: 800,
    },
    radioContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing(2),
        color: theme.palette.common.black,
    },
    radio: {
        appearance: 'none',
        outline: 'none',
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        border: '1px solid',
        borderColor: theme.palette.common.black,
        margin: 0,
        backgroundColor: theme.palette.common.white,
        position: 'relative',
        boxSizing: 'content-box',

        '&:after': {
            position: 'absolute',
            content: '" "',
            top: '4px',
            left: '4px',
            width: "6px",
            height: "6px",
            borderRadius: '50%',
            backgroundColor: theme.palette.common.black,
            display: 'none',
        },

        '&:checked': {
            '&:after': {
                display: 'block',
            }
        },

        '&:focus':{
            outline: '1px solid',
            outlineColor: theme.palette.common.black,
        }
    },
    invalidRadio: {
        borderColor: theme.palette.error.main,
    },
    focusedRadio: {
        outline: '1px solid',
        outlineColor: theme.palette.common.black,
    },
    errorMessage: {
        ...typography.feedback,
        color: theme.palette.error.main,
    },
    helpButton: {
        marginRight: theme.spacing(1.5),
    },
    helpInfo: {
        paddingRight: theme.spacing(1.5),
        paddingLeft: `calc(${theme.spacing(1.5)}px + 14px)`,
    },
});



// WEBPACK FOOTER //
// ./src/components/common/radioAccordion/radioAccordion.style.ts